import { Hub } from '@goldcast/api/backend';

import { State } from './types';

const getters = {
  getEventHubPages(state: State): Array<Hub> {
    return Object.values(state.eventHubPages);
  },
  getSingleEventHubPage: (state: State) => (eventHubPageId: string) => {
    return state.eventHubPages[eventHubPageId];
  }
};

export default getters;
